import { useCountUp } from '@/shared/hooks/useCountUp';

/**
 * מספר מונפש. format מקבל את הערך הביניים (עשרוני) ומחזיר טקסט — ברירת
 * מחדל: מספר שלם עם מפרידי אלפים. <CountUp value={974} /> / format={(v) => `${v.toFixed(1)}%`}.
 */
export function CountUp({ value, format, ms }: { value: number; format?: (v: number) => string; ms?: number }) {
  const v = useCountUp(Number.isFinite(value) ? value : 0, ms);
  return <>{format ? format(v) : Math.round(v).toLocaleString('he-IL')}</>;
}
